import { render, staticRenderFns } from "./bonnitui.vue?vue&type=template&id=8c0a3362&scoped=true&"
import script from "./bonnitui.vue?vue&type=script&lang=js&"
export * from "./bonnitui.vue?vue&type=script&lang=js&"
import style0 from "./bonnitui.vue?vue&type=style&index=0&id=8c0a3362&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0a3362",
  null
  
)

export default component.exports